import z from 'zod';
import { MANDATORY_FIELD } from '../../config/zodConfig';

export const SchoolClassFormSchema = z.object({
  id: z.number().optional(),
  name: z.string().min(1, MANDATORY_FIELD),
  recognitionsId: z.array(z.number()).min(1, MANDATORY_FIELD),
  shiftId: z.number().nullable(),
});

export type SchoolClassFormData = z.infer<typeof SchoolClassFormSchema>;
